import { render, staticRenderFns } from "./symptom-questions.vue?vue&type=template&id=a2ae6180&"
import script from "./symptom-questions.vue?vue&type=script&lang=js&"
export * from "./symptom-questions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports